var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498,123.8L498,123.8L498,123.8c-5.9-5.8-13.7-9-21.9-9c-8.2,0-16,3.2-21.8,9l0,0l0,0L256,322.5L57.9,123.8 c-5.8-5.9-13.6-9.1-21.9-9.1s-16,3.2-21.9,9.1C8.2,129.6,5,137.3,5,145.5c0,8.3,3.2,16.1,9.1,22L234.2,388 c5.8,5.9,13.6,9.2,21.9,9.2c8.2,0,16-3.2,21.8-9L498,167.6c5.8-5.8,9-13.6,9-21.8C507,137.4,503.8,129.6,498,123.8z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.427a8057.svg";
export { ForwardRef as ReactComponent };